import type { Post } from '@/stores/auth-store'
import { SERVICE_VARIANT_TYPE } from '@/lib/service-variant-types'

export const MASTER_ADMIN_PATH = '/master-admin'

/**
 * True only for a post held directly on the ELLAN root organisation (eln-org, variant 100 / ROOT-ORG).
 * Tenant and branch posts under eln-org carry other variants (102, 1400) and are excluded.
 */
export function isElnOrgRootPost(post: Post | null | undefined): boolean {
  if (!post) {
    return false
  }
  const variantUniqueId = String(post.service_variant_unique_id ?? '').trim()
  if (variantUniqueId) {
    return variantUniqueId === SERVICE_VARIANT_TYPE.ORG
  }
  const variantLabel = String(post.service_variant_name ?? post.service_variant_type ?? '')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
  return variantLabel === 'root-org'
}
